module.exports = __webpack_public_path__ + "img/AST.12148632.png";